import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import IsMobile from 'ismobilejs'
import { get, includes } from 'lodash'
import { setSnippets } from 'utils/snippets'
import { Div, Button } from '@driftt/tide-core'
import ResourceConstants from 'constants/ResourceConstants'
import urlParse from 'url-parse'

import logo from 'assets/svg/logo.svg'
import driftLoginBackground from 'assets/images/drift_login_background.jpg'
import driftLoginForeground from 'assets/images/drift_login_foreground.png'


import './style.css'

const RESET_PASSWORD_ROUTES = ["/reset", "/forgot-password"]
const SPLASH_URL = "https://www.drift.com/summit/revgrowth-digital/"
const MOBILE_VIDEO_REDIRECT_URL = '/letsgo/video/success'

const MarketingSplash = ({ redirectToSplashUrl }) => (
  <Div className="drift-auth-shuffle" style={{backgroundImage: `url(${driftLoginBackground})`, backgroundSize: 'cover'}}>
    <Div className="marketing-splash--content">
      <img src={driftLoginForeground} className="marketing-spash--content-image"/>
      <Button className="marketing-spash--cta" onClick={redirectToSplashUrl}>
        Learn More
      </Button>
    </Div>
  </Div>
)

const getClientId = (url) => {
  const shouldParseQuery = true
  return get(urlParse(url, shouldParseQuery), 'query.client_id', ResourceConstants.DEFAULT_CLIENT_ID)
}

const getRedirectUrl = (url) => {
  const shouldParseQuery = true
  return get(urlParse(url, shouldParseQuery), 'query.redirect', ResourceConstants.DEFAULT_REDIRECT_URL)
}

class Auth extends Component {

  componentWillReceiveProps(nextProps) { this.redirectToLogin(nextProps) }

  componentWillMount() {
    if (!includes(RESET_PASSWORD_ROUTES, this.props.location.pathname)
          && !includes(Object.keys(ResourceConstants.CUSTOM_CLIENTS), getClientId(this.props.location.search))
          && !getRedirectUrl(this.props.location.search).includes(MOBILE_VIDEO_REDIRECT_URL)) {
      if (IsMobile.apple.phone) {
        this.props.history.push('/download-ios-app')
        return
      }
      else if (IsMobile.android.phone || IsMobile.seven_inch) {
        this.props.history.push('/download-android-app')
        return
      }
    }

    this.redirectToLogin(this.props)
  }

  componentDidMount() {
    setSnippets()
  }

  redirectToLogin(props) {
    if (props.location.pathname === '/') { props.history.push('/login') }
  }

  redirectToSplashUrl = () => {
    const win = window.open(SPLASH_URL, '_blank')
    win.focus()
  }

  render() {
    return (
      <Div className="drift-auth-app">
      	<Div className="drift-auth-container">
          <Div className="drift-auth-content">
            <img src={logo} alt="Drift" className="logo" />
            { this.props.children }
          </Div>
        </Div>
        <MarketingSplash redirectToSplashUrl={this.redirectToSplashUrl}/>
      </Div>
    )
  }
}

const AuthLayout = withRouter(Auth)

export default AuthLayout



// WEBPACK FOOTER //
// ./src/components/layouts/Auth/index.js